import StatTile from "@/components/home/StatTile";
import { formatMoney } from "@/lib/money";
import { rateLine } from "@/pages/Revenue/rates";
import type { StockOverview } from "../lib/stockHealth";

interface Props {
  // Every market's totals added together.
  overview: StockOverview;
  // Inventory value in the display currency; null when it cannot be shown.
  value: number | null;
  displayCurrency: string;
  // The currency inventory value is stored in, and the rates to convert it.
  cogsCurrency: string;
  rates: Record<string, number>;
  // Users without the gross-margin permission get no value figures at all.
  valueVisible: boolean;
}

// The totals above the all-markets Inventory Overview: each market's
// rows added together. They follow the search, the product group filter and
// the hidden warehouse columns. No days of cover: it does not add up across
// markets.
export default function AllMarketsOverview({ overview, value, displayCurrency, cogsCurrency, rates, valueVisible }: Props) {
  const rate = rateLine(displayCurrency, cogsCurrency, rates);
  return (
    <div
      className="grid gap-3"
      style={{ gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))" }}
    >
      <StatTile label="Stock on hand" value={overview.stock.toLocaleString()}>
        units
      </StatTile>
      {valueVisible && (
        <StatTile label="Inventory value" value={value === null ? "–" : formatMoney(value, displayCurrency)}>
          {rate ? `at cost · ${rate}` : "at cost"}
        </StatTile>
      )}
      <StatTile label="Incoming" value={overview.incoming.toLocaleString()}>
        units on order
      </StatTile>
      <StatTile
        label="Stockout risk"
        value={overview.critical}
        tone={overview.critical > 0 ? "warning" : "default"}
      >
        products Critical
      </StatTile>
      <StatTile label="Order needed" value={overview.orderSoon}>
        products to order soon
      </StatTile>
      <StatTile label="Excess" value={overview.overstock}>
        products Overstock
      </StatTile>
    </div>
  );
}
